// base
import { createAction } from '@reduxjs/toolkit';

// default
export const Project = 'project';
export const PROJECT_SLICE_NAME = `${Project}Slice`;

// action
const GET_PROJECT_INFO = `${Project}/getProjectInfo`;
const UPDATE_PROJECT_INFO = `${Project}/updateProjectInfo`;
const ADD_PROJECT_IMAGE = `${Project}/addProjectImage`;
const DELETE_PROJECT_IMAGE = `${Project}/deleteProjectImage`;
const UPDATE_WORK_AREA = `${Project}/updateWorkArea`;
// createAction
export const getProjectInfoAction = createAction(GET_PROJECT_INFO);
export const updateProjectInfoAction = createAction(UPDATE_PROJECT_INFO);
export const addProjectImageAction = createAction(ADD_PROJECT_IMAGE);
export const deleteProjectImageAction = createAction(DELETE_PROJECT_IMAGE);
export const updateWorkAreaAction = createAction(UPDATE_WORK_AREA);

// actions
export const actions = {
  GET_PROJECT_INFO,
  UPDATE_PROJECT_INFO,
  ADD_PROJECT_IMAGE,
  DELETE_PROJECT_IMAGE,
  UPDATE_WORK_AREA
};
